import { cn } from "@/lib/cn";
import type { HealthStatus } from "@/lib/directory";

const COPY: Record<HealthStatus, { label: string; className: string }> = {
  // ⚠ "unknown" means the app hasn't implemented the directory endpoints yet.
  // It is rendered as nothing at all rather than as a warning: an app that
  // hasn't been wired up is not an app that is down.
  unknown: { label: "", className: "" },
  ok: { label: "Responding normally", className: "bg-success" },
  degraded: { label: "Reporting a problem", className: "bg-warning" },
  unreachable: { label: "Not responding", className: "bg-destructive" },
};

export function HealthDot({ status }: { status: HealthStatus }) {
  const copy = COPY[status];
  if (!copy.label) return null;

  return (
    <span
      title={copy.label}
      aria-label={copy.label}
      role="img"
      className={cn("inline-block h-2 w-2 shrink-0 rounded-full", copy.className)}
    />
  );
}
